import { useState } from 'react';
import { observer } from 'mobx-react';
import { henshu } from '../../henshu';
import { WatchAnchors } from '@sasaki-dev/react-anchors';
import ReactMobilized from '@sasaki-dev/react-mobilized';

import './App.scss';
import content from './store';

import Contact from './components/Contact/Contact';
import Process from './components/Process/Process';
import Resources from './components/Resources/Resources';
import Vision from './components/Vision/Vision';
import Welcome from './components/Welcome/Welcome';
import ArrowIcon from './assets/arrow-icon-blue.svg';
import CSULogo from './assets/csu-logo.jpg';
import CSUFooterLogo from './assets/csu-logo-footer.jpg';


const COMAP_URL = 'https://comap.sasaki.com/csu';

document.title = 'Cleveland State';

if (process.env.NODE_ENV !== 'development') {
    !window.heap.loaded && window.heap.load('2892254132');
    window.gtag && window.gtag('config', 'G-13M9HMGFNE');
}

export default observer(function App() {
    const { instance: store } = content;
    const [section, setSection] = useState(0);

    return (
        <div className="App">
            <ReactMobilized
                anchors={store.menu}
                breakpoint={1150}
                section={section + 1}
                setCurrentSection={n => setSection(n - 1)}
                banner={(
                    <henshu.a
                        href={COMAP_URL}
                        getter={() => store.term('banner')}
                        setter={t => store.setTerm('banner', t)}
                    />
                )}
                logo={<img src={CSULogo} alt="Cleveland State University" />}
            >
                <WatchAnchors onTop={anchor => setSection(anchor.index)} onOffscreen={anchor => !(anchor.top < 0) && setSection(anchor.index - 1)}>
                    <Welcome comap={COMAP_URL} />
                    <Vision />
                    <Process />
                    <Resources />
                    <Contact comap={COMAP_URL} section={section} />
                </WatchAnchors>
                <footer>
                    <div className="logo">
                        <img src={CSUFooterLogo} alt="Cleveland State University logo" />
                    </div>

                    <button onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}>
                        <img src={ArrowIcon} alt="" />
                    </button>
                </footer>
            </ReactMobilized>
        </div>
    );
});
